import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import { Modal } from "@mui/material";
import "./ColumnSelectModal";
import instance from "../../../../order_managment/common/api/interceptor";
import { path } from "../../../../order_managment/constants/apiPath";
import { HOST_URL } from "../../../../config";
import axios from "axios";
const style = {
  position: "absolute",
  top: "5rem",
  left: "50%",
  transform: "translate(-50%, 0)",
  width: "50%",
  minWidth: "20rem",
  bgcolor: "background.paper",
  border: "0.1rem solid #017EFA",
  boxShadow: 24,
  borderRadius: "1rem",
  padding: "1rem 0 1rem 2.5rem",
};
const ColumnSelectModal = ({
  setSelectModal,
  selectModal,
  coloumn,
  setColoumn,
  handleRequestColoumnUpdate,
}) => {
  const [columnName, setColumnName] = useState(null);
  const [selectAll, setSelectAll] = useState(null);
  useEffect(() => {
    const clonedArray = JSON.parse(JSON.stringify(coloumn));
    setColumnName([...clonedArray]);
    const booleanValue = coloumn.reduce((accumulator, obj) => {
      return accumulator && obj.value;
    }, true);
    setSelectAll(booleanValue);
  }, [coloumn]);

  const postColoumn = async () => {
    try {
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${HOST_URL}${path.SHIPMENT_COLOUM}${
          JSON.parse(localStorage.getItem("UserDataLogin")).user_name
        }`,
        headers: {
          Username: JSON.parse(localStorage.getItem("UserDataLogin")).user_name,
          Usersecret: JSON.parse(localStorage.getItem("UserDataLogin"))
            .password,
          Macaddress: "",
          Ipaddress: "",
          Devicetype: "W",
        },
        data: columnName,
      };
      await axios
        .request(config)
        .then((response) => {
          if (response?.data?.status == 1) {
            setColoumn(JSON.parse(JSON.stringify(columnName)));
            handleRequestColoumnUpdate();
          } else {
            setColumnName(JSON.parse(JSON.stringify(columnName)));
          }
        })
        .catch((error) => {
          console.log(error);
        });
      setSelectModal({
        filter: false,
        selectCol: false,
      });
    } catch (err) {
      console.log(err);
    }
  };
  const selectAllHanlder = (state) => {
    const columnNameAllUpdated = columnName.map((obj) => {
      if (obj.captionColumnName == "SX_Is_SH_ShipmentId") return obj;
      else {
        obj.value = state;
        return obj;
      }
    });
    setColumnName([...columnNameAllUpdated]);
  };
  return (
    <Modal
      open={selectModal?.selectCol}
      className={`modalBox _orderColumnSelect`}
      onClose={() =>
        setSelectModal({
          filter: false,
          selectCol: false,
        })
      }
    >
      <Box sx={style}>
        <div className="modalHeader">
          <h5>Select Columns</h5>
          <div
            className="closeIcon"
            onClick={() =>
              setSelectModal({
                filter: false,
                selectCol: false,
              })
            }
          >
            <CloseIcon
              onClick={() =>
                setSelectModal({
                  filter: false,
                  selectCol: false,
                })
              }
            />
          </div>
        </div>
        <div
          className="_solidButton"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div>
            <button
              onClick={() => {
                const state = !selectAll;
                setSelectAll((prev) => !prev);
                selectAllHanlder(state);
              }}
            >
              {" "}
              {selectAll ? "deselect all" : "Select All"}
            </button>
          </div>
          <div style={{ marginRight: "28px" }}>
            <button onClick={postColoumn}>Apply</button>
          </div>
        </div>
        <div className="_modalBody container-fluid">
          <div className="row selectColumnRow">
            {columnName?.map((item, index) => {
              return (
                <div className="col-6 check_Container" key={index}>
                  <input
                    disabled={
                      item.displayColumnName == "Shipment Number" ? true : false
                    }
                    checked={item.value}
                    onChange={(event) => {
                      columnName[index].value = event?.target?.checked;
                      setColumnName([...columnName]);
                    }}
                    //   checked={activeCol[item.key]}
                    type="checkbox"
                    key={index}
                    id={"vehicle" + index}
                  />
                  <span>{item.displayColumnName}</span>
                </div>
              );
            })}
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default ColumnSelectModal;
